import * as React from 'react';
import { Platform, StyleSheet, Text, TextProps } from 'react-native';
import PlatformColor from './PlatformColor';
import useDialogTheme, { StyleBuilder } from './useTheme';

export type DialogTitleProps = TextProps;

const DialogTitle: React.FC<DialogTitleProps> = props => {
  const { style, children, ...nodeProps } = props;
  const { styles } = useDialogTheme(buildStyles);

  return (
    <Text style={[styles.text, style]} {...nodeProps}>
      {children}
    </Text>
  );
};

DialogTitle.displayName = 'DialogTitle';

const buildStyles: StyleBuilder = isDark =>
  StyleSheet.create({
    text: Platform.select({
      default: {
        color: PlatformColor('label'),
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '600',
      },
      android: {
        color: PlatformColor(
          `@android:color/${
            isDark ? 'primary_text_dark' : 'primary_text_light'
          }`,
        ),
        fontWeight: '500',
        fontSize: 18,
      },
    }),
  });

export default DialogTitle;
